/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import {
	addCompareProduct,
	setCompareBarProducts,
	setCompareProductDetails,
	setCompareProductDetailsCallFailed,
	setCompareProductsAvailability,
	setCompareSkeletonLoader,
	setIsCompareFeatureHidden,
	setIsCompareGridOpen
} from './compare.actions';

import { CompareState } from '@plp/data-access/interfaces';

export const initialCompareState: CompareState = {
	compareBarProducts: [],
	compareProductsAvailability: { ecodeMessagingMap: {} },
	hasProductDetailsCallFailed: false,
	isCompareFeatureHidden: true,
	isCompareGridOpen: false,
	isCompareSkeletonLoaderVisible: true,
	productDetails: null
};

const productCompareReducer = createReducer(
	initialCompareState,
	on(setCompareBarProducts, (state, { compareBarProducts }) => ({
		...state,
		compareBarProducts
	})),
	on(addCompareProduct, (state, { compareBarProduct }) => {
		const newCompareList = [...state.compareBarProducts, compareBarProduct];
		return {
			...state,
			compareBarProducts: newCompareList
		};
	}),
	on(setCompareProductDetails, (state, { productDetails }) => ({
		...state,
		productDetails
	})),
	on(setCompareSkeletonLoader, (state, { isCompareSkeletonLoaderVisible }) => ({
		...state,
		isCompareSkeletonLoaderVisible
	})),
	on(setCompareProductDetailsCallFailed, (state, { hasProductDetailsCallFailed }) => ({
		...state,
		hasProductDetailsCallFailed
	})),
	on(setIsCompareFeatureHidden, (state, { isCompareFeatureHidden }) => ({
		...state,
		isCompareFeatureHidden
	})),
	on(setIsCompareGridOpen, (state, { isCompareGridOpen }) => ({
		...state,
		isCompareGridOpen
	})),
	on(setCompareProductsAvailability, (state, { compareProductsAvailability }) => ({
		...state,
		compareProductsAvailability
	}))
);

export function compareReducer(state: CompareState | undefined, action: Action) {
	return productCompareReducer(state, action);
}
